// src/pages/Dashboard.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import nooLogo from '../assets/noo.png';
import leftArrowIcon from '../assets/left.png';

const displayFont = { fontFamily: "'Sora', ui-sans-serif, system-ui, sans-serif" };
const bodyFont = { fontFamily: "'Inter', ui-sans-serif, system-ui, sans-serif" };
const monoFont = { fontFamily: "'IBM Plex Mono', ui-monospace, SFMono-Regular, monospace" };

const statusStyles = {
  Scheduled: 'bg-[#4FB3A9]/15 text-[#0F3D3E]',
  Completed: 'bg-[#0F3D3E] text-white',
  Cancelled: 'bg-red-100 text-red-700',
};

const statusDot = {
  Scheduled: 'bg-[#4FB3A9]',
  Completed: 'bg-[#0F3D3E]',
  Cancelled: 'bg-red-500',
};

const Dashboard = () => {
  const mockDoctors = [
    { id: 'doc1', name: 'Dr. Ahmed Hassan', specialty: 'Gastroenterology' },
    { id: 'doc2', name: 'Dr. Sara Ali', specialty: 'Hepatology' },
    { id: 'doc3', name: 'Dr. Omar Mahmoud', specialty: 'Endoscopy' },
  ];

  const mockPatients = [
    { id: 'pat001', name: 'Nour Ali', doctorId: 'doc1' },
    { id: 'pat002', name: 'Fatma Khaled', doctorId: 'doc2' },
    { id: 'pat003', name: 'Mohamed Tarek', doctorId: 'doc1' },
    { id: 'pat004', name: 'Layla Said', doctorId: 'doc3' },
    { id: 'pat005', name: 'Karim Adel', doctorId: 'doc2' },
  ];

  const mockAppointments = [
    { id: 'app1', patientId: 'pat001', patientName: 'Nour Ali', doctorId: 'doc1', doctorName: 'Dr. Ahmed Hassan', date: '2024-08-01', time: '10:00', status: 'Scheduled' },
    { id: 'app2', patientId: 'pat002', patientName: 'Fatma Khaled', doctorId: 'doc2', doctorName: 'Dr. Sara Ali', date: '2024-08-01', time: '11:30', status: 'Scheduled' },
    { id: 'app3', patientId: 'pat003', patientName: 'Mohamed Tarek', doctorId: 'doc1', doctorName: 'Dr. Ahmed Hassan', date: '2024-08-01', time: '14:00', status: 'Completed' },
    { id: 'app4', patientId: 'pat004', patientName: 'Layla Said', doctorId: 'doc3', doctorName: 'Dr. Omar Mahmoud', date: '2024-08-02', time: '09:30', status: 'Scheduled' },
    { id: 'app5', patientId: 'pat005', patientName: 'Karim Adel', doctorId: 'doc2', doctorName: 'Dr. Sara Ali', date: '2024-08-02', time: '10:30', status: 'Cancelled' },
    { id: 'app6', patientId: 'pat001', patientName: 'Ahmed Samy', doctorId: 'doc1', doctorName: 'Dr. Ahmed Hassan', date: '2024-08-02', time: '16:00', status: 'Scheduled' },
  ];

  const [currentUserRole, setCurrentUserRole] = useState('admin');
  const [currentDoctorId, setCurrentDoctorId] = useState('doc1');

  const doctorAppointments = mockAppointments.filter(app => app.doctorId === currentDoctorId);

  const totalAppointments = mockAppointments.length;
  const scheduledAppointments = mockAppointments.filter(app => app.status === 'Scheduled').length;
  const completedAppointments = mockAppointments.filter(app => app.status === 'Completed').length;
  const cancelledAppointments = mockAppointments.filter(app => app.status === 'Cancelled').length;
  const totalPatients = mockPatients.length;
  const totalDoctors = mockDoctors.length;

  return (
    <div className="min-h-screen bg-[#FAF9F6]" style={bodyFont}>
      {/* Header */}
      <div className="bg-white border-b border-[#E4E1D8]">
        <div className="container mx-auto px-4 md:px-8 py-4 flex flex-wrap items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <Link to="/home">
              <img src={nooLogo} alt="Drogastro" className="w-12 h-12 object-contain" />
            </Link>
            <div>
              <p className="text-[11px] tracking-wider text-[#0F3D3E]/50" style={monoFont}>OVERVIEW</p>
              <h1 className="text-xl md:text-2xl font-bold text-[#0F3D3E]" style={displayFont}>
                {currentUserRole === 'admin' ? 'Admin Dashboard' : 'Doctor Dashboard'}
              </h1>
            </div>
          </div>

          <div className="flex flex-wrap items-center gap-3">
            <div className="flex gap-1 p-1 bg-[#FAF9F6] rounded-md border border-[#E4E1D8]">
              <button
                onClick={() => setCurrentUserRole('admin')}
                className={`px-4 py-2 rounded-md font-semibold text-sm transition-colors duration-200 ${
                  currentUserRole === 'admin' ? 'bg-[#0F3D3E] text-white' : 'text-[#22262B] hover:bg-[#E4E1D8]'
                }`}
              >
                Admin View
              </button>
              <button
                onClick={() => setCurrentUserRole('doctor')}
                className={`px-4 py-2 rounded-md font-semibold text-sm transition-colors duration-200 ${
                  currentUserRole === 'doctor' ? 'bg-[#0F3D3E] text-white' : 'text-[#22262B] hover:bg-[#E4E1D8]'
                }`}
              >
                Doctor View
              </button>
            </div>
            {currentUserRole === 'doctor' && (
              <select
                value={currentDoctorId}
                onChange={(e) => setCurrentDoctorId(e.target.value)}
                className="p-2 border border-[#E4E1D8] rounded-md text-sm bg-white focus:outline-none focus:ring-2 focus:ring-[#4FB3A9] transition-shadow"
              >
                {mockDoctors.map(doc => (
                  <option key={doc.id} value={doc.id}>{doc.name}</option>
                ))}
              </select>
            )}
            <Link
              to="/home"
              className="flex items-center gap-2 bg-[#FAF9F6] hover:bg-[#E4E1D8] text-[#0F3D3E] font-semibold py-2 px-4 rounded-md border border-[#E4E1D8] transition-colors duration-200 text-sm"
            >
              <img src={leftArrowIcon} alt="Back" className="w-4 h-4" /> Back to Home
            </Link>
          </div>
        </div>
      </div>

      <div className="container mx-auto px-4 md:px-8 py-6 md:py-8">
        <div className="bg-white rounded-xl border border-[#E4E1D8] shadow-sm p-6 md:p-8">
          {currentUserRole === 'admin' ? (
            <div>
              <h2 className="text-lg md:text-xl font-bold text-[#0F3D3E] mb-6" style={displayFont}>Clinic Overview</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 mb-8">
                <div className="p-5 rounded-lg border border-[#E4E1D8] border-l-4 border-l-[#0F3D3E]">
                  <p className="text-4xl font-bold text-[#0F3D3E]" style={displayFont}>{totalAppointments}</p>
                  <p className="text-[11px] font-semibold text-[#22262B]/60 uppercase tracking-wider mt-2" style={monoFont}>Total Appointments</p>
                </div>
                <div className="p-5 rounded-lg border border-[#E4E1D8] border-l-4 border-l-[#4FB3A9]">
                  <p className="text-4xl font-bold text-[#0F3D3E]" style={displayFont}>{totalPatients}</p>
                  <p className="text-[11px] font-semibold text-[#22262B]/60 uppercase tracking-wider mt-2" style={monoFont}>Total Patients</p>
                </div>
                <div className="p-5 rounded-lg border border-[#E4E1D8] border-l-4 border-l-[#D6A419]">
                  <p className="text-4xl font-bold text-[#0F3D3E]" style={displayFont}>{totalDoctors}</p>
                  <p className="text-[11px] font-semibold text-[#22262B]/60 uppercase tracking-wider mt-2" style={monoFont}>Total Doctors</p>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="p-5 md:p-6 rounded-lg border border-[#E4E1D8]">
                  <h3 className="text-base font-bold text-[#0F3D3E] mb-4" style={displayFont}>Appointments Status</h3>
                  <ul className="space-y-3 text-sm">
                    <li className="flex items-center justify-between">
                      <span className="flex items-center gap-2 text-[#22262B]/80">
                        <span className="w-2 h-2 rounded-full bg-[#4FB3A9]" /> Scheduled
                      </span>
                      <span className="font-semibold text-[#0F3D3E]">{scheduledAppointments}</span>
                    </li>
                    <li className="flex items-center justify-between">
                      <span className="flex items-center gap-2 text-[#22262B]/80">
                        <span className="w-2 h-2 rounded-full bg-[#0F3D3E]" /> Completed
                      </span>
                      <span className="font-semibold text-[#0F3D3E]">{completedAppointments}</span>
                    </li>
                    <li className="flex items-center justify-between">
                      <span className="flex items-center gap-2 text-[#22262B]/80">
                        <span className="w-2 h-2 rounded-full bg-red-500" /> Cancelled
                      </span>
                      <span className="font-semibold text-red-600">{cancelledAppointments}</span>
                    </li>
                  </ul>
                </div>

                <div className="p-5 md:p-6 rounded-lg border border-[#E4E1D8]">
                  <h3 className="text-base font-bold text-[#0F3D3E] mb-4" style={displayFont}>Our Doctors</h3>
                  <ul className="space-y-3 text-sm">
                    {mockDoctors.map(doc => (
                      <li key={doc.id} className="flex items-center justify-between border-b border-[#E4E1D8] last:border-0 pb-2 last:pb-0">
                        <span className="font-semibold text-[#22262B]">{doc.name}</span>
                        <span className="text-[#22262B]/60 text-xs" style={monoFont}>{doc.specialty}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ) : (
            <div>
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-lg md:text-xl font-bold text-[#0F3D3E]" style={displayFont}>My Appointments</h2>
                <span className="text-xs font-semibold text-[#0F3D3E]/50 bg-[#FAF9F6] border border-[#E4E1D8] rounded-full px-3 py-1" style={monoFont}>
                  {doctorAppointments.length} TOTAL
                </span>
              </div>
              {doctorAppointments.length === 0 ? (
                <div className="flex flex-col items-center justify-center text-center py-14 px-6 bg-[#FAF9F6] rounded-lg border border-dashed border-[#E4E1D8]">
                  <p className="text-[#22262B]/60 text-base">No appointments scheduled for you.</p>
                </div>
              ) : (
                <div className="overflow-x-auto rounded-md border border-[#E4E1D8]">
                  <table className="min-w-full bg-white">
                    <thead className="bg-[#0F3D3E]/5">
                      <tr>
                        <th className="py-3 px-4 text-left text-xs font-semibold text-[#0F3D3E] uppercase tracking-wider" style={monoFont}>Date</th>
                        <th className="py-3 px-4 text-left text-xs font-semibold text-[#0F3D3E] uppercase tracking-wider" style={monoFont}>Time</th>
                        <th className="py-3 px-4 text-left text-xs font-semibold text-[#0F3D3E] uppercase tracking-wider" style={monoFont}>Patient</th>
                        <th className="py-3 px-4 text-left text-xs font-semibold text-[#0F3D3E] uppercase tracking-wider" style={monoFont}>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {doctorAppointments.map(app => (
                        <tr key={app.id} className="border-t border-[#E4E1D8] hover:bg-[#FAF9F6] transition-colors">
                          <td className="py-3 px-4 whitespace-nowrap text-[#22262B]">{app.date}</td>
                          <td className="py-3 px-4 whitespace-nowrap text-[#22262B] font-semibold" style={monoFont}>{app.time}</td>
                          <td className="py-3 px-4 whitespace-nowrap text-[#22262B]">{app.patientName}</td>
                          <td className="py-3 px-4 whitespace-nowrap">
                            <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold ${statusStyles[app.status] || 'bg-gray-200 text-gray-800'}`}>
                              <span className={`w-1.5 h-1.5 rounded-full ${statusDot[app.status] || 'bg-gray-500'}`} />
                              {app.status}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
